import { Component, OnInit } from '@angular/core';
import { DummiesService } from '../../core/services/dummies.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UiService } from '../../core/services/ui.service';

@Component({
  selector: 'dummies-create',
  templateUrl: 'dummies-create-edit.template.html',
})
export class DummiesCreateComponent implements OnInit {
  public dummy;
  constructor(
    private dummiesSrv: DummiesService,
    private route: ActivatedRoute,
    private router: Router,
    private ui: UiService
  ) {}
  ngOnInit() {
    this.dummy = this.dummiesSrv.create();
  }
  handleSubmit(evt) {
    evt.preventDefault();
    this.saveDummy();
  }
  saveDummy() {
    this.dummiesSrv.save(this.dummy).then((dummy) => {
      this.ui.snackbar.show({
        message: 'Dummy created!',
      });
      this.router.navigate(['/dummies/' + dummy.id]);
    });
  }
}
